<template>
    <div ref="multicircle-graph" class="chart-container">
        <div class="d-flex justify-content-center align-items-center h-100" v-if="loading">
            <b-skeleton-icon
                icon="circle-fill"
                :icon-props="{ fontScale: 15 }"
            />
        </div>
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import {mapGetters} from "vuex"

    export default {
        name: "MulticircleGraph",
        props:{
            roles: Array
        },
        data(){
            return{
                series: null,
                isIE11: false,
                loading: true
            }
        },
        mounted() {
            setTimeout(()=>{
                this.initGraph();
            }, 500)
        },
        computed:{
            ...mapGetters({
                locale: 'user/getLocale'
            })
        },
        methods:{
            initGraph(){
                let chart = am4core.create(this.$refs['multicircle-graph'], am4charts.RadarChart);
                let chartData = [];

                this.isIE11 = navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > -1;

                chartData.push({
                    "category": "IO",
                    "value": "100",
                    "fill": "100"
                });

                this.roles.map(function(role){
                    chartData.push({
                        "category": role,
                        "value": "100",
                        "fill": "100"
                    })
                });

                // Themes begin
                if(!this.isIE11){
                    am4core.useTheme(am4themes_animated);
                }
                // Themes end

                var colorSet = new am4core.ColorSet();
                colorSet.list = [
                    am4core.color("#FFB996"),
                    am4core.color("#AE263E"),
                    am4core.color("#5A0E77"),
                    am4core.color("#F4828C"),
                    am4core.color("#E6B200"),
                    am4core.color("#2B4E9E"),
                    am4core.color("#009692"),
                    am4core.color("#73B8CD"),
                    am4core.color("#A468D5"),
                    am4core.color("#FF671D"),
                ];

                chart.colors = colorSet;

                // Add data
                chart.data = chartData;

                // Make chart not full circle
                chart.startAngle = -135;
                chart.endAngle = 225;
                chart.innerRadius = am4core.percent(0);

                // Set number format
                chart.numberFormatter.numberFormat = "";

                // Create axes
                var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "category";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.grid.template.strokeOpacity = 0;
                categoryAxis.renderer.inside=true;
                categoryAxis.renderer.minGridDistance = 10;

                if(this.isIE11){
                    categoryAxis.renderer.labels.template.horizontalCenter = "left";
                    categoryAxis.renderer.labels.template.paddingLeft = 120;
                    categoryAxis.renderer.labels.template.minHorizontalGap = 0;
                    categoryAxis.renderer.labels.template.autoWrap = false;
                    categoryAxis.renderer.labels.template.gridPosition = "start";
                    categoryAxis.renderer.labels.template.fontWeight = 500;
                    categoryAxis.renderer.labels.template.adapter.add("fill", function(fill, target) {
                        return (target.dataItem.index >= 0) ? chart.colors.getIndex(target.dataItem.index) : fill;
                    });
                }
                else{
                    categoryAxis.renderer.labels.template.hide();
                }

                var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.grid.template.strokeOpacity = 0;
                valueAxis.min = 0;
                valueAxis.max = 100;
                valueAxis.strictMinMax = true;

                // Create series
                this.series = chart.series.push(new am4charts.RadarColumnSeries());
                this.series.dataFields.valueX = "value";
                this.series.dataFields.categoryY = "category";
                this.series.clustered = false;
                this.series.sequencedInterpolation = true;

                this.series.columns.template.adapter.add("fill", function(fill, target) {
                    return chart.colors.getIndex(target.dataItem.index);
                });

                this.series.columns.template.strokeOpacity = 0;
                this.series.columns.template.width = am4core.percent(100);

                const self = this;
                if(!this.isIE11){
                    this.series.events.on("ready", function () {
                        var columns = self.series.columns.values;
                        var interval = 1200/self.series.columns.length;
                        columns.map(function(column, index){
                            setTimeout(self.addSingleLabel, 1200 + interval*(index), column, index, columns);
                        });
                    });
                }

                this.chart = chart;
            },
            addSingleLabel(column, index, columns){
                if(!columns || columns.length === 0){
                    return;
                }
                var padding = columns[0].column.bbox.width/6;
                var label = this.series.createChild(am4core.Label);
                label.strokeOpacity = 0;
                label.fill = am4core.color("#ffffff");
                label.fillOpacity = 1;
                label.horizontalCenter = "left";
                label.fontWeight="900";
                if(index !== 0){
                    label.path = columns[index-1].column.slice.path;
                    label.padding(0, 0, padding, 0);
                    label.text = this.roles[index-1];
                    label.fontSize = 16;
                }
                else{
                    label.horizontalCenter = "middle";
                    label.padding(-5, 0, 0, 0);
                    label.text = this.locale === 'it' ? 'IO' : 'ME';
                }

                label.animate({ property: "opacity", from: 0, to: 1 }, 500);
            },
        },
        beforeDestroy() {
            if (this.chart) {
                this.chart.dispose();
            }
        }
    }
</script>

<style scoped>
    .chart-container{
        height: 400px;
    }
</style>